import Component from '@glimmer/component'
import { HomeTile } from 'teacher-ui-client/components/home/tile'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

type ReadingOrMaths = SubscriptionType.Reading | SubscriptionType.Maths

interface Args {
  subscriptionType: ReadingOrMaths
}

interface VideoSource {
  src: string
  title: string
}

const videoSources: Record<ReadingOrMaths, VideoSource> = {
  [SubscriptionType.Reading]: {
    src: 'https://www.youtube.com/embed/QJcgNHTq7Qc',
    title: 'YouTube video player - Fast Phonics',
  },
  [SubscriptionType.Maths]: {
    src: 'https://www.youtube.com/embed/B2Hj9j5T0dw',
    title: 'YouTube video player - Mathseeds',
  },
}

export class HomeTilesVideo extends Component<Args> {
  get videoSource() {
    return videoSources[this.args.subscriptionType]
  }
  <template>
    <HomeTile>
      <iframe
        class="snappy:invisible h-full w-full"
        src={{this.videoSource.src}}
        title={{this.videoSource.title}}
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </HomeTile>
  </template>
}

export default HomeTilesVideo
